module.exports = __webpack_public_path__ + "img/julien_clerc-duos.3e34d57b.jpg";